// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__hg+vq","spinner":"Spinner_spinner__o3WR4","rotate":"Spinner_rotate__6GkZb"};